module.exports = __webpack_public_path__ + "img/logo.695d1eaf.svg";